// Parameter tetap untuk GET /WA/inits. Dipakai useLoadInits & useRefetchInits
// supaya query key dan payload selalu identik.
export const INITS_PARAMS = {
  include_ticket: 1,
  active_only: 1,
  // Minta daftar izin user dalam format flat. BUKAN kode kompatibilitas — ini
  // opt-in ke BE, jadi jangan ikut dihapus saat cleanup-permission-legacy.
  // Lihat panduan cleanup di src/utils/permission.js.
  permission_list: 1,
};
